// Same hex convention as ObservabilityLayout's chartPalettes.agents. These are identity colours
// (they must stay stable for a given user across themes and sessions), not theme colours, so they
// are intentionally literal rather than derived from the shell tokens.
const PALETTE = ['#2563eb', '#0891b2', '#16a34a', '#f59e0b', '#7c3aed', '#db2777'];

function hashToIndex(key: string, mod: number): number {
  let hash = 2166136261;
  for (let i = 0; i < key.length; i++) {
    hash ^= key.charCodeAt(i);
    hash = Math.imul(hash, 16777619);
  }
  return (hash >>> 0) % mod;
}

export interface MemberAvatarProps {
  email: string;
  userId: string;
}

export function MemberAvatar({ email, userId }: MemberAvatarProps) {
  const color = PALETTE[hashToIndex(userId, PALETTE.length)];
  const initials = email.slice(0, 2).toUpperCase();

  return (
    // `aria-hidden`: the initials are a visual shorthand for the email address rendered right beside
    // it, so announcing them makes every member read as "A R arvind@ncoder.ai".
    <div
      aria-hidden
      className="grid h-7 w-7 shrink-0 place-items-center rounded-full text-[11px] font-semibold leading-none text-white ring-1 ring-inset ring-black/10"
      style={{ backgroundColor: color }}
    >
      {initials}
    </div>
  );
}
